import React, { useState } from "react"
import { Link } from "react-router-dom"
import { t } from '../../components/i18n/i18n'
import back from "../../assets/images/elements/archiveHeader.jpg"
// Імпортуємо наш масив з даними
import { articlesData } from "../../assets/data/articles"

export const Resources = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = event => {
    setSearchTerm(event.target.value);
  };

  const filteredArticles = articlesData.filter((article) => {
    if (!searchTerm.trim()) return true;

    const searchWords = searchTerm.trim().toLowerCase().split(/\s+/);

    const translatedTitle = t(article.titleKey) ? t(article.titleKey).toLowerCase() : '';
    const translatedAuthor = t(article.authorKey) ? t(article.authorKey).toLowerCase() : '';
    const translatedDesc = t(article.descriptionKey) ? t(article.descriptionKey).toLowerCase() : '';

    const allKeywords = [...(article.keywords_ua || []), ...(article.keywords_en || [])].map(k => k.toLowerCase());

    return searchWords.every(word => {
      return (
        translatedTitle.includes(word) ||
        translatedAuthor.includes(word) ||
        translatedDesc.includes(word) ||
        allKeywords.some((keyword) => keyword.includes(word))
      );
    });
  });

  return (
    <section className='blog'>
      <div className='container_100'>
        <div className='backImg15'>
          <img src={back} alt='' />
          <div className='text_container_dark_15_top'>
            <div className='h1_15 margin0'>{t("resourcesHeader")}</div>
            <center>
              <input
                type="text"
                placeholder={t("search")}
                value={searchTerm}
                onChange={handleSearch}
              />
            </center>
          </div>
        </div>

        <br />
        <div className='container boxItems'>
          <h1 className='menuColor'>{t("resourcesSubtitle")}</h1>
          <br />

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
            gap: '30px'
          }}>
            {filteredArticles.map((article) => (

              <div className='box' key={article.id} style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '20px',
                padding: '15px',
                border: '1px solid #eaeaea',
                borderRadius: '8px',
                backgroundColor: '#fff'
              }}>

                <div className='img-container' style={{
                  flex: '0 0 160px',
                  overflow: 'hidden',
                  borderRadius: '6px'
                }}>
                  <Link to={article.url}>
                    <img
                      src={article.img}
                      alt={t(article.titleKey)}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                        transition: 'transform 0.3s ease'
                      }}
                      onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                      onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    />
                  </Link>
                </div>

                <div className='details' style={{
                  flex: '1',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}>
                  <div>
                    <Link to={article.url} style={{ textDecoration: 'none' }}>
                      <h3 className='menuColor' style={{ fontSize: '1.2rem', marginBottom: '8px', lineHeight: '1.3' }}>
                        {t(article.titleKey)}
                      </h3>
                    </Link>
                    <p style={{ color: '#777', fontSize: '0.9rem', marginBottom: '12px' }}>
                      <em>{t(article.authorKey)}</em>
                    </p>
                    <p style={{ color: '#444', fontSize: '0.95rem', lineHeight: '1.5', marginBottom: '15px' }}>
                      {t(article.descriptionKey)}
                    </p>
                  </div>

                  <Link to={article.url} className='readMore' style={{
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    alignSelf: 'flex-start'
                  }}>
                    {t("resourceReadMore")} →
                  </Link>
                </div>

              </div>
            ))}
          </div>

          {filteredArticles.length === 0 && (
            <div style={{ textAlign: 'center', marginTop: '20px', color: '#777' }}>
              Нічого не знайдено
            </div>
          )}

        </div>
        <br />
      </div>
    </section>
  )
}
